<template>
  <div
    id="loader"
    class="loading-animation"
    :class="{ opaque: open, displayed: isDisplayed }"
  >
    <div class="dots">
      <div class="dot dot-1"></div>
      <div class="dot dot-2"></div>
      <div class="dot dot-3"></div>
      <div class="dot dot-4"></div>
      <div class="dot dot-5"></div>
    </div>
    <div class="message">
      <!-- Use the default slot to pass in a message shown beneath -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "NsGlobalLoaderVue",
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      isDisplayed: false,
      /**
       * ID of the z-index setter function timeout
       * @private
       */
      timeoutId: ""
    };
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        clearTimeout(this.timeoutId);
        this.isDisplayed = true;
      } else {
        this.timeoutId = setTimeout(() => {
          this.isDisplayed = false;
        }, 300);
      }
    }
  }
  // methods: {
  //   isOpen(open) {
  //       if(!open) {
  //           this.timeoutId = setTimeout(() => {
  //               this.$.loader.style.zIndex = '-1'
  //           }, 300)
  //           return ''
  //       } else {
  //           this.$.loader.style.zIndex = '10000'
  //           clearTimeout(this.timeoutId)
  //           return 'open'
  //       }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.loading-animation {
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  overflow-y: auto;
  opacity: 0;
  transition: opacity 0.3s ease;
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  animation: fadein 0.3s ease;
  z-index: 1000;
}

.displayed {
  display: flex;
}

.opaque {
  opacity: 1;
}

.dots {
  margin-bottom: 40px;
}

.message {
  font-size: 18px;
  font-weight: 700;
}

.dot {
  /* top: 50%; */
  display: inline-block;
  position: relative;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  animation: dotAnim, dotFade;
  animation-duration: 2.5s;
  animation-timing-function: cubic-bezier(0.09, 0.04, 0.49, 2.37), ease-in-out;
  animation-iteration-count: infinite;
  animation-fill-mode: backwards;
  background-color: #008ab0;
  transform: translateY(0);
  opacity: 0.2;
}

.dot:not(:last-child) {
  margin-right: 0.75rem;
}

.dot.dot-1 {
  animation-delay: 0.1s, 0.2s;
}

.dot.dot-2 {
  animation-delay: 0.2s, 0.3s;
}

.dot.dot-3 {
  animation-delay: 0.3s, 0.4s;
}

.dot.dot-4 {
  animation-delay: 0.4s, 0.5s;
}

.dot.dot-5 {
  animation-delay: 0.5s, 0.6s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes dotFade {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }

  25% {
    opacity: 0.75;
  }
}

@keyframes dotAnim {
  0%,
  50%,
  100% {
    transform: translateY(-100%);
  }

  25% {
    transform: translateY(100%);
  }
}
</style>
